<template>
  <div class="my-layout-box ">
    <!-- 订单信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>订单信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>入仓单号：</span>
            <i class="c-code-color"> {{ items.Code }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>报关类型：</span>
            <i>单抬头 正能量开具增值税发票</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>单据状态：</span>
            <i :class="items.Status==0? 'c-unSubmit-color': items.Status ==1? 'c-unAudit-color': items.Status == 2? 'c-audit-color': ''">{{
              items.IsDeprecated? "作废": items.Status == 0 ? "待提交": items.Status == 1? "待审核": items.Status == 2? "已审核" : ""
            }}</i>
          </li>
          <li>
            <span>付款方式：</span>
            <i :class='items.PaymentType? "c-four-color":"c-one-color"'>{{ items.PaymentTypeStr }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">

          <li>
            <span>下单日期：</span>
            <i>{{ items.CreatedAt | FormatDate }}</i>
          </li>
          <li>
            <span>币别：</span>
            <i>{{ items.CurrencyType }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>付款银行: </span>
            <i>{{ items.BankName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>供应商：</span>
            <i>{{ items.SupplierName }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 产品信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>产品信息</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>
      </section>
    </section>
    <!-- 香港交货方式 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>香港交货方式</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>交货方式：</span>
            <i :class='items.HKReceivingType==1?"c-one-color": items.HKReceivingType == 2? "c-two-color": "c-three-color"'>{{
              items.HKReceivingType == 1
                ? "供应商配送"
                : items.HKReceivingType == 2
                ? "正能量代提货"
                : "快递"
            }}</i>
          </li>
          <li>
            <span>清关服务: </span>
            <i>{{ items.IsClearCustoms ? "需要清关" : "不需要清关" }}</i>
          </li>
        </ul>

        <!-- 供应商配送 -->
        <div v-if="items.HKReceivingType == 1">
          <ul class="c-content-ul">
            <li>
              <span>联系人: </span>
              <i>赵丽云</i>
            </li>
            <li>
              <span>联系电话: </span>
              <i>852-35292686</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址: </span>
              <i>九龍觀塘成業街19-21號 成業工業大廈3樓32-33室 </i>
            </li>
          </ul>
        </div>

        <!-- 正能量代提货 -->
        <div v-if="items.HKReceivingType == 2">
          <ul class="c-content-ul">
            <li>
              <span>联系人: </span>
              <i>{{ items.HKReceivingContact }}</i>
            </li>
            <li>
              <span>联系电话: </span>
              <i>{{ items.HKReceivingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址: </span>
              <i>{{ items.HKReceivingAddress }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>提货备注: </span>
              <i>{{ items.PickupGoodsRemark }}</i>
            </li>
          </ul>
        </div>

        <!-- 快递 -->
        <div v-if="items.HKReceivingType == 3">
          <ul class="c-content-ul">
            <li>
              <span>快递公司: </span>
              <i>{{ items.HKReceivingExpressName }}</i>
            </li>
            <li>
              <span>快递单号:</span>
              <i>{{ items.HKReceivingExpressNo }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>代垫运费：</span>
              <i>{{ items.ReimbursedExpenses ? "是" : "否" }}</i>
            </li>
          </ul>
        </div>

        <div style="margin-top: 5px">
          <ul class="c-content-ul">
            <li>
              <span>理货要求:</span>
              <i>{{ items.TallyRequirements }}</i>
            </li>
          </ul>
        </div>
      </section>
    </section>

    <!-- 国内物流 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>国内物流信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>交货方式：</span>
            <i :class='items.StockOutType==1?"c-one-color": items.StockOutType == 2? "c-two-color": "c-three-color"'>{{
              items.StockOutType == 1 ? "正能量送货" : items.StockOutType == 2 ? "自提" : "待确认"
            }}</i>
          </li>
        </ul>
        <!-- 正能量送货 -->
        <div v-if="items.StockOutType == 1">
          <ul class="c-content-ul">
            <li>
              <span>收货人: </span>
              <i>{{ items.ShippingContact }}</i>
            </li>
            <li>
              <span>联系人: </span>
              <i>{{ items.ShippingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址: </span>
              <i> {{ items.ShippingFullAddress }}</i>
            </li>
          </ul>
        </div>

        <div v-if="items.StockOutType == 2">
          <ul class="c-content-ul">
            <li>
              <span>提货人: </span>
              <i>{{ items.ShippingContact }}</i>
            </li>
            <li>
              <span>提货电话: </span>
              <i>{{ items.ShippingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>身份证号: </span>
              <i> {{ items.ShippingCode }}</i>
            </li>
          </ul>
        </div>

        <div style="margin-top: 5px">
          <ul class="c-content-ul">
            <li>
              <span>订单备注: </span>
              <i> {{ items.Remark }}</i>
            </li>
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { getOrderDetail } from "~/api/order";
import { orderDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
const paymentMap = {
  1: "T.T(转账)",
  2: "COD(支票结算)",
  3: "不付货款",
  4: "其他方式"
};
export default {
  name: "orderDetail",
  components: {
    DetailList
  },
  data() {
    return {
      items: {},
      listMap: orderDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        Id: id
      };
      let data = await getOrderDetail(params);
      data.PaymentTypeStr = paymentMap[data.PaymentType];
      this.items = data;
      this.$refs.detailList.getList(data.LineList);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
